(function ($) {
	$(document).ready(function () {
		//PCは隠さない
		if (window.matchMedia('(max-width: 767px)').matches) {
			$('.js-acc__body').hide();
			$('.js-acc').on("click", function () {
				$(this).toggleClass('js-acc--open')
				$(this).next('.js-acc__body').slideToggle(200);
				return false;
			});
		} else {
		}
	});
})(jQuery);
